import { v4 as uuid } from "uuid";
import type { ModalTabItem } from "./tabbed-modal-types";

function normalizeTabCode(code?: string | null): string {
	return code?.trim()
		.toLowerCase()
		.replace(/[\s_]+/g, "-") ?? "";
}

export class ModalTabHandle {
	public readonly hash: string;
	public readonly isAvailable: boolean;
	public readonly isDisabled: boolean;
	public readonly isSelectable: boolean;
	public readonly panelId: string;
	public readonly tabId: string;

	public static normalizeCode(code?: string | null): string {
		return normalizeTabCode(code);
	}

	public constructor(
		public readonly tab: ModalTabItem,
		public readonly element?: Element
	) {
		const id = `tabbed-modal-${uuid()}`;
		this.hash = normalizeTabCode(tab.code);
		this.isAvailable = tab.isAvailable !== false;
		this.isDisabled = tab.isDisabled === true;
		this.isSelectable = this.isAvailable && !this.isDisabled;
		this.panelId = `${id}-panel`;
		this.tabId = `${id}-tab`;
	}

	public get name(): string {
		return this.tab.name;
	}

	public get code(): string {
		return this.tab.code;
	}

	public isSame(tab?: ModalTabHandle | ModalTabItem | string | null): boolean {
		if(tab === undefined || tab === null) {
			return false;
		}

		if(typeof tab !== "string" && !(tab instanceof ModalTabHandle) && this.tab === tab) {
			return true;
		}

		const hash = typeof tab === "string"
			? normalizeTabCode(tab)
			: tab instanceof ModalTabHandle
				? tab.hash
				: normalizeTabCode(tab.code);

		return this.hash !== "" && this.hash === hash;
	}
}
